// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiPencil } from "@mdi/js";

import { ShapefileAction as GeomBinAction } from "../..";

interface IGeomBinViewDetailsActionProps {
  isDisabled?: boolean;
  closePopover: () => void;
  geomBinEditAction?: () => void;
}

export function GeomBinEditAction({
  isDisabled,
  closePopover,
  geomBinEditAction
}: IGeomBinViewDetailsActionProps) {
  return (
    <GeomBinAction
      disabled={isDisabled}
      placement="bottom"
      onClick={(evt) => {
        geomBinEditAction();
        closePopover();
        evt.stopPropagation();
        evt.preventDefault();
      }}>
      <Icon path={mdiPencil} size={"18px"} />
      Edit Polygon Bin
    </GeomBinAction>
  );
}
